import styled from '@emotion/styled';

const drawerWidth = '400px';
const drawerSpeed = '0.1s';

export const DevToolsButton = styled.button<{ isOpen: boolean }>`
  position: fixed;
  bottom: 45%;
  right: ${props => (props.isOpen ? drawerWidth : '0px')};
  transition: right ${drawerSpeed} ease-in-out;
  width: 28px;
  height: 194px;
  padding: 5px 8px;
  overflow-wrap: break-word;
  text-align: center;
  border-right: none;
  border: none;
  margin: 0;
  z-index: 97;
  background-color: #393939;
  color: #fff;
  box-shadow: 0 0 3px #393939;
  cursor: pointer;
  user-select: none;

  :hover {
    background-color: #454545;
  }
`;

export const ForceMountButton = styled(DevToolsButton)`
  bottom: calc(45% + 194px);
  height: auto;
  background-color: #188a24;
  z-index: 98;
  font-size: 20px;
  line-height: 1;

  :hover {
    background-color: #139c21;
  }
`;

export const HideDevToolsButton = styled(DevToolsButton)`
  bottom: calc(45% - 27.5px);
  height: auto;
  background-color: #e75555;

  :hover {
    background-color: #e80c0c;
  }
`;

export const Drawer = styled.div<{ isOpen: boolean }>`
  position: fixed;
  bottom: 0;
  right: 0;
  width: ${props => (props.isOpen ? drawerWidth : '0px')};
  height: 100vh;
  background: white;
  overflow-y: scroll;
  padding-bottom: 10px;
  box-shadow: ${props => (props.isOpen ? '4px 0px 8px 3px #393939' : 'none')};
  z-index: 99;
  transition: width ${drawerSpeed} ease-in-out;

  nav {
    margin: 0;
  }
`;
